<template>
  <div class="answers_value" :class="{ 'answers_value--videoresume': isVideoresume }">
    <vtextarea
      id="application"
      ref="application_editor"
      v-model="answer_val"
      resizable-y
      auto_height
      name="application"
      :class="['application']"
      :placeholder="$tr('interview.tests.all.questions.answers.answer.value')"
    />
  </div>
</template>

<script>
  export default {
    name: 'AnswersValue',
    props: ['data', 'id', 'isVideoresume'],
    data() {
      return {
        answer: ''
      };
    },

    computed: {
      answer_val: {
        get() {
          return this.answer;
        },

        set(v) {
          this.answer = v;
          this.update();
        }
      }
    },

    methods: {
      update() {
        this.$emit('update', {
          question_id: this.id,
          text: this.answer
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .answers_value {
    ::v-deep .application.ql-container.ql-editor {
      padding: 13px 20px;
      font-size: 15px;
      line-height: 22px;
    }

    ::v-deep {
      .quillWrapper {
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: flex-start;
      }
    }

    ::v-deep .ql-editor.ql-blank:before {
      top: 13px;
      left: 15px;
      right: 20px;
    }

    &.answers_value--videoresume ::v-deep {
      .ql-editor {
        padding: 12px;
        // font-family: 'Euclid Circular A';
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 24px;

        * {
          // font-family: 'Euclid Circular A';
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 24px;
        }
      }

      .quillWrapper .ql-container.ql-snow {
        border: 1px solid #d1d8e0;
        border-radius: 4px;
      }
    }
  }
</style>
